import React from 'react';
import Table from 'App/components/Table';
import * as R from 'ramda';
import createUserLinkCell from '../../components/UserLinkCell/createUserLinkCell';
import propOrDash from 'App/utils/propOrDash';
import PendingUserActionsCell from './PendingUserActionsCell';
import useFetchDisabledCompanySsoUsersQuery from 'App/hooks/useFetchDisabledCompanySsoUsersQuery';
import { USER_LINK_PATHS } from 'App/features/UserManager/constants';

const propTypes = {};

const defaultProps = {};

function tableStateReducer(state, action, prevState) {
    const { type } = action;
    switch (type) {
        case 'resetFilters':
        case 'resetPage':
        case 'resetSortBy': {
            return prevState;
        }

        case 'setFilter': {
            return R.set(R.lensProp('pageIndex'), 0, state);
        }

        case 'init': {
            return R.set(R.lensProp('sortBy'), [{ id: 'firstName', desc: false }], state);
        }
        default: {
            return state;
        }
    }
}

const columns = [
    {
        Header: 'First Name',
        accessor: propOrDash('firstName'),
        id: 'firstName',
        Cell: createUserLinkCell(USER_LINK_PATHS.edit.key),
    },
    {
        Header: 'Last Name',
        accessor: propOrDash('lastName'),
        id: 'lastName',
        Cell: createUserLinkCell(USER_LINK_PATHS.edit.key),
    },
    {
        Header: 'Email',
        accessor: propOrDash('email'),
        id: 'email',
        Cell: createUserLinkCell(USER_LINK_PATHS.edit.key),
    },
    {
        Header: 'Actions',
        id: 'actions',
        Cell: PendingUserActionsCell,
    },
];

function PendingActivationTable() {
    const { isLoading, data = [] } = useFetchDisabledCompanySsoUsersQuery();

    return (
        <Table
            columns={columns}
            data={data}
            isLoading={isLoading}
            stateReducer={tableStateReducer}
            getKey={R.prop('id')}
        />
    );
}

PendingActivationTable.propTypes = propTypes;
PendingActivationTable.defaultProps = defaultProps;

export default PendingActivationTable;
